import './styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/app';
import { createSession } from './features/auth/session';
import { initI18n, resolveUiLocale } from './i18n';
import { initAnalytics } from './lib/analytics';
import { applyStartParam } from './lib/deep-link';
import { readEnv } from './lib/env';
import { initTelegram } from './lib/telegram';

async function start(): Promise<void> {
	const root = document.getElementById('root');
	if (root === null) throw new Error('#root is missing in index.html');

	const env = readEnv();
	// The dev-only initData is ignored in production builds.
	const launch = await initTelegram(
		env.DEV && env.VITE_DEV_INIT_DATA !== undefined ? { devInitData: env.VITE_DEV_INIT_DATA } : {},
	);
	// Before auth we only know Telegram's language; the saved user locale wins after login.
	await initI18n(resolveUiLocale(launch.languageCode));
	initAnalytics({
		key: env.VITE_POSTHOG_KEY,
		host: env.VITE_POSTHOG_HOST,
		startParam: launch.startParam,
		platform: launch.platform,
		version: launch.version,
	});
	applyStartParam(launch.startParam, window.history, window.location.pathname);
	const session = createSession({ initData: launch.initData, baseUrl: env.VITE_API_URL });

	createRoot(root).render(
		<StrictMode>
			<App session={session} insideTelegram={launch.initData !== null} />
		</StrictMode>,
	);
}

void start();
